{
  "(optional)": "(nepovinné)",
  "(required)": "(povinné)"
}